import { render, staticRenderFns } from "./lianxi.vue?vue&type=template&id=125c5abe&scoped=true"
import script from "./lianxi.vue?vue&type=script&lang=js"
export * from "./lianxi.vue?vue&type=script&lang=js"
import style0 from "./lianxi.vue?vue&type=style&index=0&id=125c5abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c5abe",
  null
  
)

export default component.exports